import React, { useEffect, useState } from "react";
import { Phone, Mail, MapPin, Instagram, Facebook, Twitter, FileDown } from "lucide-react";
import axios from "axios";
import { SHOP } from "@/constants/testIds";
import { brandLogo } from "@/constants/brandLogos";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function Footer() {
  const [pricelists, setPricelists] = useState([]);

  useEffect(() => {
    axios.get(`${BACKEND}/api/pricelists`).then((res) => setPricelists(res.data || [])).catch(() => {});
  }, []);

  return (
    <footer data-testid={SHOP.footer} className="mt-16 sm:mt-24 bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2">
              <img
                src="https://static.prod-images.emergentagent.com/jobs/0c393ec1-3405-4eb1-be58-a2051533df5b/images/fb222513f0229b28878ce0533de4e321210e334f5bf1c00ab4d490f4f96d70dc.png"
                alt="Adeshwar Electricals logo"
                className="w-10 h-10 rounded-lg object-contain"
              />
              <div>
                <div className="font-display font-extrabold text-white text-lg">Adeshwar</div>
                <div className="text-[11px] font-bold tracking-[0.18em] text-[#FFD700] uppercase">Electricals</div>
              </div>
            </div>
            <p className="mt-4 text-sm text-gray-400 leading-relaxed">
              India&apos;s fastest electrical-goods delivery. 100% genuine products, lowest prices, fastest delivery.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full bg-gray-800 hover:bg-[#FF5722] grid place-items-center transition-colors">
                <Instagram size={16} />
              </a>
              <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-full bg-gray-800 hover:bg-[#0056D2] grid place-items-center transition-colors">
                <Facebook size={16} />
              </a>
              <a href="#" aria-label="Twitter" className="w-9 h-9 rounded-full bg-gray-800 hover:bg-[#0056D2] grid place-items-center transition-colors">
                <Twitter size={16} />
              </a>
            </div>
          </div>

          <div>
            <div className="text-xs font-bold uppercase tracking-[0.18em] text-white mb-3">Shop</div>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:text-[#FFD700] transition-colors">Wires & Cables</a></li>
              <li><a href="#" className="hover:text-[#FFD700] transition-colors">Switches & Sockets</a></li>
              <li><a href="#" className="hover:text-[#FFD700] transition-colors">LED Lighting</a></li>
              <li><a href="#" className="hover:text-[#FFD700] transition-colors">Ceiling Fans</a></li>
              <li><a href="#" className="hover:text-[#FFD700] transition-colors">Inverters</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs font-bold uppercase tracking-[0.18em] text-white mb-3">Pricelists</div>
            {pricelists.length === 0 ? (
              <p className="text-xs text-gray-500">Latest brand pricelists coming soon.</p>
            ) : (
              <ul className="space-y-2 text-sm" data-testid="footer-pricelists">
                {pricelists.map((pl) => {
                  const logo = brandLogo(pl.brand);
                  return (
                  <li key={pl.brand}>
                    <a
                      data-testid={`pricelist-download-${pl.brand.toLowerCase().replace(/[^a-z0-9]/g, "")}`}
                      href={`${BACKEND}${pl.url}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 hover:text-[#FFD700] transition-colors"
                    >
                      {logo ? (
                        <span className="w-8 h-5 rounded bg-white grid place-items-center overflow-hidden shrink-0">
                          <img src={logo} alt={`${pl.brand} logo`} className="max-w-[26px] max-h-[14px] object-contain" />
                        </span>
                      ) : (
                        <FileDown size={13} />
                      )}
                      {pl.brand} Pricelist
                    </a>
                  </li>
                  );
                })}
              </ul>
            )}
          </div>

          <div>
            <div className="text-xs font-bold uppercase tracking-[0.18em] text-white mb-3">Company</div>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:text-[#FFD700] transition-colors">About Us</a></li>
              <li><a href="#" className="hover:text-[#FFD700] transition-colors">Bulk Orders</a></li>
              <li><a href="#" className="hover:text-[#FFD700] transition-colors">Track Order</a></li>
              <li><a href="#" className="hover:text-[#FFD700] transition-colors">Returns</a></li>
              <li><a href="#" className="hover:text-[#FFD700] transition-colors">Terms & Privacy</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs font-bold uppercase tracking-[0.18em] text-white mb-3">Get in touch</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Phone size={14} className="text-[#FFD700] mt-1 shrink-0" />
                <span>080-41249285<br /><span className="text-xs text-gray-500">8 AM – 8 PM, all days</span></span>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={14} className="text-[#FFD700] mt-1 shrink-0" />
                <span>amitchajjed@yahoo.com</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={14} className="text-[#FFD700] mt-1 shrink-0" />
                <span>30/1 M.T. Street, B.V.K. Iyengar Road Cross,<br />Opp. Ram Temple, Chickpet,<br />Bangalore – 560053</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-gray-500">
          <div>© {new Date().getFullYear()} Adeshwar Electricals. All rights reserved.</div>
          <div>Made with ⚡ in Bangalore</div>
        </div>
      </div>
    </footer>
  );
}
